import type { ChangeEvent } from 'react';

import { InputType } from '@/components/BaseLibrary/FormInput/FormInput';

export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export const maskInputChangeEvent = (
  event: ChangeEvent<HTMLInputElement>,
  type: InputType
): ChangeEvent<HTMLInputElement> => {
  if (type === InputType.NUMBER) {
    event.target.value = event.target.value.replace(/[^0-9]/g, '');
    return event;
  } else if (type === InputType.DOLLAR) {
    const replacedVal = event.target.value.replace(/[^0-9]/g, '');
    event.target.value =
      replacedVal.length > 0 ? `$${replacedVal}` : replacedVal;
    return event;
  } else {
    return event;
  }
};

export const toCamelCase = (str: string) => {
  return (
    str
      .toLowerCase()
      // biome-ignore lint/correctness/noUnusedFunctionParameters: Automated migration to Biome
      .replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase())
  );
};
